module.exports = __webpack_public_path__ + "static/media/REST2.43efcf55.png";